'use strict';

var peerId = require('peer-id');

var waterfall = require('async/waterfall');

var parallel = require('async/parallel');

var promisify = require('promisify-es6');

var defaultsDeep = require('@nodeutils/defaults-deep');

var defaultConfig = require('../runtime/config-nodejs.js');

var Keychain = require('libp2p-keychain');

var addDefaultAssets = require('./init-assets');

module.exports = function init(self) {
  return promisify(function (opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    var done = function done(err, res) {
      if (err) {
        self.emit('error', err);
        return callback(err);
      }

      self.preStart(function (err) {
        if (err) {
          self.emit('error', err);
          return callback(err);
        }

        self.state.initialized();
        self.emit('init');
        callback(null, res);
      });
    };

    if (self.state.state() !== 'uninitialized') {
      return done(new Error('Not able to init from state: ' + self.state.state()));
    }

    self.state.init();
    self.log('init'); // An initialized, open repo was passed, use this one!

    if (opts.repo) {
      self._repo = opts.repo;
      return done(null, true);
    }

    opts.emptyRepo = opts.emptyRepo || false;
    opts.bits = Number(opts.bits) || 2048;

    opts.log = opts.log || function () {};

    var config = defaultsDeep(self._options.config, defaultConfig());
    var privateKey;
    waterfall([// Verify repo does not yet exist.
    function (cb) {
      return self._repo.exists(cb);
    }, function (exists, cb) {
      self.log('repo exists?', exists);

      if (exists === true) {
        return cb(new Error('repo already exists'));
      }

      if (opts.privateKey) {
        self.log('using user-supplied private-key');

        if (typeof opts.privateKey === 'object') {
          cb(null, opts.privateKey);
        } else {
          peerId.createFromPrivKey(Buffer.from(opts.privateKey, 'base64'), cb);
        }
      } else {
        // Generate peer identity keypair + transform to desired format + add to config.
        opts.log("generating ".concat(opts.bits, "-bit RSA keypair..."), false);
        self.log('generating peer id: %s bits', opts.bits);
        peerId.create({
          bits: opts.bits
        }, cb);
      }
    }, function (peerId, cb) {
      self.log('identity generated');
      config.Identity = {
        PeerID: peerId.toB58String(),
        PrivKey: peerId.privKey.bytes.toString('base64')
      };
      privateKey = peerId.privKey;

      if (opts.pass) {
        config.Keychain = Keychain.generateOptions();
      }

      opts.log('done');
      opts.log('peer identity: ' + config.Identity.PeerID);

      self._repo.init(config, cb);
    }, function (_, cb) {
      return self._repo.open(cb);
    }, function (cb) {
      self.log('repo opened');

      if (opts.pass) {
        self.log('creating keychain');
        var keychainOptions = Object.assign({
          passPhrase: opts.pass
        }, config.Keychain);
        self._keychain = new Keychain(self._repo.keys, keychainOptions);

        self._keychain.importPeer('self', {
          privKey: privateKey
        }, cb);
      } else {
        cb(null, true);
      }
    }, // add empty unixfs dir object (go-ipfs assumes this exists)
    function (_, cb) {
      if (opts.emptyRepo) {
        return cb(null, true);
      }

      var tasks = [function (cb) {
        waterfall([function (cb) {
          return self.object.new('unixfs-dir', cb);
        }, function (emptyDirNode, cb) {
          return self._ipns.initializeKeyspace(privateKey, emptyDirNode.toJSON().multihash, cb);
        }], cb);
      }];

      if (typeof addDefaultAssets === 'function') {
        // addDefaultAssets is undefined on browsers.
        // See package.json browser config
        tasks.push(function (cb) {
          return addDefaultAssets(self, opts.log, cb);
        });
      }

      self.log('adding assets');
      parallel(tasks, function (err) {
        if (err) {
          cb(err);
        } else {
          cb(null, true);
        }
      });
    }], done);
  });
};